<template>
    <div v-if="consultation">
        <b-modal
            size="lg"
            v-model="modalShow"
            title="請求内容のご確認"
            :ok-title="isMethodCredit ? '請求を確定' : '請求書をメール送付'"
            ok-variant="yokumiru-orange"
            cancel-title="戻る"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="cancel"
            @hidden="cancel">
            <form @submit.stop.prevent="authConfirmInvoice">
                <dl>
                    <dt>{{ $locale.consultation_host }}ID</dt>
                    <dd>
                        <span>{{ `#${consultation.id}` }}</span><!--
                        --><span class="small text-muted">{{ `（${consultation.user.full_name}）` }}</span>
                    </dd>
                </dl>

                <hr style="border-style: dotted">

                <dl>
                    <dt>請求金額</dt>
                    <dd>
                        <span class="lead font-weight-bold">{{ consultation.invoice.total.toLocaleString() }}</span><!--
                        --><span class="small">&nbsp;円</span><!--
                        --><span class="small">{{ `（${consultation.payment_method.name}）` }}</span>
                    </dd>
                </dl>
            </form>

            <div
                v-if="errors.stripe"
                class="invalid-feedback d-flex justify-content-center mt-3">
                <div v-if="errors.stripe.code === 'card_declined'">カード会社によって支払いが拒否されました。</div>
                <div v-else-if="errors.stripe.type === 'card_error'">このカードは利用できません。</div>
                <div v-else-if="errors.stripe.message === 'Invoice is already paid'">既に支払い済みの請求書です。</div>
                <div v-else-if="['api_connection_error', 'api_error'].includes(errors.stripe.type)">
                    決済システムのメンテナンス中です。時間を置いて再度お試しください。
                </div>
            </div>
            <div
                v-else-if="errors.message"
                class="invalid-feedback d-flex justify-content-center mt-3">
                {{ errors.message[0] }}
            </div>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    export default {
        name: "AuthConfirmInvoiceModal",

        data: function() {
            return {
                inProgress :false,
                modalShow: false,
                consultation: null,
                userType: null,
                errors: {},
            }
        },

        computed: {
            /**
             * 支払い方法がクレジットカードか判定
             *
             * @return {boolean}
             */
            isMethodCredit: function () {
                if (!this.consultation) return false
                return this.consultation.payment_method_id === constants.payment_methods.credit
            },
        },

        created: function () {
            bus.$on('open-modal-auth-confirm-invoice', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-auth-confirm-invoice')
        },

        methods: {
            open: function (consultation, userType) {
                this.consultation = consultation
                this.userType = userType
                this.modalShow = true
            },

            handleOk(e) {
                e.preventDefault()
                this.authConfirmInvoice()
            },

            authConfirmInvoice: async function () {
                if (this.inProgress) return
                this.inProgress = true

                let endpoint = ''
                const options = {headers: {'Content-Type': 'multipart/form-data'}}

                if (this.userType === 'admin') {
                    endpoint = `${constants.admin.invoices.endpoint.base}/${this.consultation.invoice.id}/auth_confirm`
                }
                else if (this.userType === 'doctor') {
                    endpoint = `${constants.doctor.invoices.endpoint.base}/${this.consultation.invoice.id}/auth_confirm`
                }

                await axios.post(endpoint, options)
                    .then(({data}) => {
                        bus.$emit('invoice-attempted', data.data)
                        bus.$emit('alert-success', '請求を行いました。')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger', '請求できませんでした。エラー内容をご確認ください。')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            cancel: function () {
                this.initialize()
                this.close()
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.consultation = null
                this.errors = {}
            },
        },
    }
</script>
